<div class="p-4 md:p-8  dark:bg-gray-900/50  h-full overflow-y-auto  ">
    <div class="bg-white dark:bg-gray-800/50 rounded-xl shadow-sm  overflow-hidden">

        <div class="p-6">
            <div class="flex flex-col md:flex-row md:items-center justify-between gap-4">

                <div>
                    <h2 class="text-xl font-bold text-gray-800 dark:text-gray-200">รายการสิทธิ์ส่วนลด</h2>
                    <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">จัดการข้อมูลคูปองและสิทธิ์ต่างๆ</p>
                </div>

                <div class="flex flex-col md:flex-row gap-3 items-end md:items-center">

                    <div
                        class="flex items-center gap-2 bg-gray-50 dark:bg-gray-800 p-1 rounded-lg border border-gray-200 dark:border-gray-700">
                        <input type="date"
                            class="bg-transparent border-none text-gray-600 dark:text-gray-300 text-sm focus:ring-0 p-2 cursor-pointer"
                            [(ngModel)]="startDate" title="วันที่เริ่มต้น">
                        <span class="text-gray-400 dark:text-gray-500">-</span>
                        <input type="date"
                            class="bg-transparent border-none text-gray-600 dark:text-gray-300 text-sm focus:ring-0 p-2 cursor-pointer"
                            [(ngModel)]="endDate" title="วันที่สิ้นสุด">
                    </div>

                    <div class="relative w-[200px]">
                        <app-input [placeholder]="'ค้นหา ชื่อ, สถานที่, บัตร...'" [type]="'text'"
                            [disabledValidate]="true" [valueIn]="searchCouponCode"
                            (valueOut)="onSearchCouponCode($event)" class="block w-full dark:text-gray-500"></app-input>
                    </div>

                    <button (click)="onClickSearch()"
                        class="cursor-pointer bg-(--bg-theme-color) hover:bg-(--bg-theme-color-btn-hover) text-white p-2.5 rounded-lg transition-colors shadow-sm flex items-center justify-center">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                        </svg>
                    </button>
                </div>
            </div>
        </div>

        <div class="relative overflow-x-auto">
            <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                <thead
                    class="text-xs text-gray-700 dark:text-gray-300 uppercase bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
                    <tr>
                        <th scope="col" class="px-6 py-4 font-semibold">ชื่อ</th>
                        <th scope="col" class="px-6 py-4 font-semibold">ประเภทบัตร</th>
                        <th scope="col" class="px-6 py-4 font-semibold">สถานที่</th>
                        <th scope="col" class="px-6 py-4 font-semibold text-center">จำนวน</th>
                        <th scope="col" class="px-6 py-4 font-semibold">ระยะเวลา</th>
                        <th scope="col" class="px-6 py-4 font-semibold">สร้างเมื่อ</th>
                        <th scope="col" class="px-6 py-4 font-semibold text-center">สถานะ</th>
                        <th scope="col" class="px-6 py-4 font-semibold text-center">Action</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
                    <tr *ngFor="let c of filteredAndPaginatedData; let i = index" (click)="navigateToDetailById(c.id)"
                        class="bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors cursor-pointer group">

                        <td class="px-6 py-4 whitespace-nowrap">
                            <div class="flex items-center">
                                <div
                                    class="flex-shrink-0 w-9 h-9 rounded-full bg-blue-100 dark:bg-blue-900 flex items-center justify-center text-blue-600 dark:text-blue-300 font-bold text-xs mr-3">
                                    {{ c.name.charAt(0) }}
                                </div>
                                <div>
                                    <div class="text-sm font-medium text-gray-900 dark:text-gray-100">{{ c.name }}</div>
                                    <div class="text-xs text-gray-400 dark:text-gray-500">ID: {{ c.id }}</div>
                                </div>
                            </div>
                        </td>

                        <td class="px-6 py-4 font-medium text-gray-900 dark:text-gray-100">
                            <span class=" text-xs font-medium px-2.5 py-1.5 rounded-full" [ngClass]="{
                                    'bg-pink-100 text-pink-600': c.cardTyieId === 3,
                                    'bg-purple-100 text-purple-600': c.cardTyieId == 4
                                }">
                                {{ c.cardTypeName }}
                            </span>
                        </td>
                        <td class="px-6 py-4">{{ c.siteName }}</td>
                        <td class="px-6 py-4 text-center font-semibold text-gray-700 dark:text-gray-300">{{ c.qty }}
                        </td>

                        <td class="px-6 py-4">
                            <div class="flex flex-col">
                                <span class="text-gray-900 dark:text-gray-100">{{ c.startDate | date: 'dd/MM/yyyy'
                                    }}</span>
                                <span class="text-xs text-gray-400 dark:text-gray-500">ถึง {{ c.endDate | date:
                                    'dd/MM/yyyy' }}</span>
                            </div>
                        </td>

                        <td class="px-6 py-4 text-gray-500 dark:text-gray-400">{{ c.createDate | date: 'dd/MM/yyyy' }}
                        </td>

                        <td class="px-6 py-4 text-center">
                            <span
                                class="inline-flex items-center justify-center px-3 py-1 text-xs font-medium rounded-full min-w-[80px]"
                                [ngClass]="{
                                    'bg-yellow-100 text-yellow-700': c.status == 1,
                                    'bg-blue-100 text-blue-700': c.status == 2,
                                    'bg-green-100 text-green-700': c.status == 3,
                                    'bg-red-100 text-red-700': c.status == 4
                                }">
                                <span class="w-1.5 h-1.5 mr-1.5 rounded-full" [ngClass]="{
                                        'bg-yellow-500': c.status == 1,
                                        'bg-blue-500': c.status == 2,
                                        'bg-green-500': c.status == 3,
                                        'bg-red-500': c.status == 4
                                    }"></span>
                                {{ c.status == 1 ? 'รออนุมัติ' : c.status == 2 ? 'อนุมัติ' : c.status == 3 ? 'เสร็จสิ้น'
                                : 'ยกเลิก' }}
                            </span>
                        </td>

                        <td class="px-6 py-4 text-center">
                            <button
                                class="text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors p-2 rounded-full hover:bg-blue-50 dark:hover:bg-gray-600">
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z">
                                    </path>
                                </svg>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div
            class="flex flex-col md:flex-row items-center justify-between p-6 border-t border-gray-100 dark:border-gray-700 bg-white dark:bg-gray-800">

            <div class="flex gap-2 mb-4 md:mb-0">
                <button (click)="prevPage()" [disabled]="currentPage === 1"
                    class="cursor-pointer px-4 py-2 text-sm font-medium  bg-(--bg-theme-color-btn) rounded-lg text-white hover:bg-(--bg-theme-color-btn-hover) disabled:opacity-50 disabled:text-gray-600 dark:disabled:text-gray-400 disabled:cursor-not-allowed transition-colors">
                    Previous
                </button>
                <button (click)="nextPage()" [disabled]="currentPage === totalPages"
                    class="cursor-pointer px-4 py-2 text-sm font-medium text-white bg-(--bg-theme-color-btn) rounded-lg hover:bg-(--bg-theme-color-btn-hover) disabled:opacity-50 disabled:cursor-not-allowed shadow-sm transition-colors">
                    Next
                </button>
            </div>

            <span class="text-sm text-gray-600 dark:text-gray-400">
                Page <span class="font-semibold text-gray-900 dark:text-gray-100">{{ currentPage }}</span> of <span
                    class="font-semibold text-gray-900 dark:text-gray-100">{{ totalPages }}</span>
            </span>

            <div class="flex items-center gap-2 mt-4 md:mt-0">
                <span class="text-sm text-gray-500 dark:text-gray-400">Rows per page:</span>

                <select (change)="onPageSizeChange($event)" [value]="pageSize"
                    class="text-sm border-gray-200 dark:border-gray-700 rounded-lg focus:ring-blue-500 focus:border-blue-500 bg-gray-50 dark:bg-gray-700 dark:text-gray-200 cursor-pointer p-2">
                    <option [value]="5">5</option>
                    <option [value]="10">10</option>
                    <option [value]="20">20</option>
                    <option [value]="50">50</option>
                </select>

            </div>

        </div>
    </div>
</div>

<app-pss-loading *ngIf="isLoading"></app-pss-loading>